'use client';

import { setShopId } from '@theme/utils/personaclick';
import { useEffect } from 'react';

export default function PersonaClickLoader() {
  const SHOP_ID = process.env.NEXT_PUBLIC_PERSONACLICK_SHOP_ID || '5eec8e9f3c21611ec0eba3cc578850';

  useEffect(() => {
    if (SHOP_ID) setShopId(SHOP_ID);
  }, [SHOP_ID]);

  return null;
}
